module.exports = __webpack_public_path__ + "img/info.006.d1589e65.jpeg";